// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
function DynamicTruncate(Props) {
  var lines = Props.lines;
  var lineHeightOpt = Props.lineHeight;
  var classNameOpt = Props.className;
  var dataTestId = Props.dataTestId;
  var fwdRef = Props.fwdRef;
  var children = Props.children;
  var lineHeight = lineHeightOpt !== undefined ? lineHeightOpt : 0;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var tmp;
  switch (lines) {
    case 1:
      tmp = "truncate-lines truncate-lines-1";
      break;
    case 2:
      tmp = "truncate-lines truncate-lines-2";
      break;
    case 3:
      tmp = "truncate-lines truncate-lines-3";
      break;
    case 4:
      tmp = "truncate-lines truncate-lines-4";
      break;
    case 6:
      tmp = "truncate-lines truncate-lines-6";
      break;
    case 8:
      tmp = "truncate-lines truncate-lines-8";
      break;
    case 5:
    case 7:
    case 9:
    case 10:
    case 11:
      tmp = "";
      break;
    case 12:
      tmp = "truncate-lines truncate-lines-12";
      break;
    default:
      tmp = "";
  }
  var className$1 = Cn.make([CSS$Showside.prefix(tmp), className]);
  var tmp$1 = {
    className: className$1
  };
  if (fwdRef !== undefined) {
    tmp$1.ref = Caml_option.valFromOption(fwdRef);
  }
  var tmp$2 = lineHeight !== 0 ? {
    minHeight: CSS$Showside.intToPx(Math.imul(lineHeight, lines))
  } : undefined;
  if (tmp$2 !== undefined) {
    tmp$1.style = Caml_option.valFromOption(tmp$2);
  }
  var tmp$3 = {
    children: React.createElement("div", tmp$1, children)
  };
  if (dataTestId !== undefined) {
    tmp$3.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  return React.createElement(DataAttribute$Showside.make, tmp$3);
}
DynamicTruncate.displayName = "DynamicTruncate";
var make = React.memo(DynamicTruncate);
export { make };
/* make Not a pure module */